<template>
  <div class="introducer-report">
    <el-card class="box-card">
      <el-tabs>
        <el-tab-pane label="Introducer Report">
          <IntroducerReportList :project="project" />
        </el-tab-pane>
        <el-tab-pane label="Introducer Summary">
          <IntroducerReportSummary :project="project" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import IntroducerReportList from "./introducer-report-list";
import IntroducerReportSummary from "./introducer-report-summary";
import { mapGetters } from "vuex";

export default {
  components: {
    IntroducerReportList,
    IntroducerReportSummary,
  },
  props: {
    project: String,
  },
  computed: {
    ...mapGetters(["user_project", "company_uid"]),
  },
};
</script>

<style lang="scss">
.introducer-report {
  .table-area {
    min-height: 200px;
  }
}
</style>